import React, { Component } from 'react';
import { SFCContainer, SFCWrapper, SFCIconBtnWrapper, SFCIconBtn, SFCMenuWrapper, FondosWrapper } from './SelectorFonsCartograficElement';
import { SFCMenuItem } from './SFCMenuItem';
import { getTranslatedKey } from '../Utils/TranslateUtils';

export class SelectorFonsCartografic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuCompacted: false, //variable de estado que indica si el menú de capas de fondo es el compactado o ampliado.
      hovering: false //variable del estado de la posicion del scroll del menú de capas.
    };
  }

  /**
   * @desc función que cambia el estado del menú desplegable de cartografias de abierto a cerrado.
   */
  onClickMainSFC = () => {
    this.props.toggleMapSelector(!this.props.isOpen);
  };
  componentDidMount = () => {};

  componentDidUpdate = (prevProps) => {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ menuCompacted: true });
      if (this.props.isOpen) {
        let fons = this.props.fonsData[this.props.fonsActiu].infoMiniaturaCarto;
        let selected = document.getElementById(fons);
        if (selected) {
          selected.scrollIntoView();
        }
      }
    }
  };

  /**
   * @desc función que cambia el estado del tipo de menú desplegable: compactado o extendido.
   */
  onClickCompactedBtn = () => {
    // this.setState({ menuCompacted: !this.state.menuCompacted });
    if (window.innerWidth < 464 && this.props.infoPuntObert) {
      this.props.changeLlegendaOpen(false);
    }
  };

  /**
   * @param {*} nFons
   * @desc función que cambia el estado del fondo cartográfico seleccionado.
   */
  onClickFonsMapa = (nFons) => {
    this.props.onChangeFonsActiuMapa(nFons);
    if (window.innerWidth < 464) {
      this.props.toggleMapSelector(!this.props.isOpen);
    }
  };

  onHoverMenuCartografic = (state) => {
    this.setState({ hovering: state });
  };

  render() {
    return (
      <>
        <SFCContainer
          id="SFC-container"
          selected={this.props.isOpen}
          infoPuntObert={this.props.infoPuntObert}
          alturaBtnSelectorFons={this.props.alturaBtnSelectorFons}
          hideBottomButtons={this.props.hideBottomButtons}>
          <SFCWrapper id="SFC-Wrapper">
            <SFCIconBtnWrapper id="SFC-btn-wrapper">
              <SFCIconBtn
                title={getTranslatedKey('selectorFons')}
                id="SFC-btn"
                selected={this.props.isOpen}
                onClick={() => this.onClickMainSFC()}
                aria-label={getTranslatedKey('aria_fonsBtn')}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 283.5 283.5"
                  space="preserve"
                  width="26"
                  fill={this.props.isOpen ? '#333333' : 'white'}>
                  <path
                    d="M272,1.4c-1.6,0-3.1,0.4-4.5,1.1l-75.9,38L105.7,2.3c-0.1-0.1-0.3-0.1-0.5-0.1c-0.4-0.1-0.8-0.3-1.2-0.4
			c-0.4-0.1-0.8-0.2-1.2-0.3c-0.8-0.1-1.6-0.1-2.4,0c-0.4,0.1-0.8,0.1-1.2,0.3C98.8,1.9,98.4,2,98,2.2c-0.2,0.1-0.3,0.1-0.5,0.1
			L7.4,42.4c-3.6,1.6-6,5.2-6,9.2V272c0,3.4,1.7,6.5,4.6,8.4c2.8,1.9,6.4,2.1,9.5,0.8l86.1-38.3l86.1,38.3c0.2,0.1,0.3,0,0.5,0.1
			c2.4,1.1,5.2,1,7.6-0.2c0.2-0.1,0.3,0,0.5-0.1l80.2-40.1c3.4-1.7,5.5-5.2,5.5-9V11.5C282,5.9,277.5,1.4,272,1.4z M91.6,225.4
			l-70.1,31.2V58.1l70.1-31.2V225.4z M181.8,256.6l-70.1-31.2V26.9l70.1,31.2V256.6z M262,225.7l-60.1,30.1V57.7L262,27.7V225.7z"></path>{' '}
                </svg>
              </SFCIconBtn>
            </SFCIconBtnWrapper>
            <SFCMenuWrapper
              open={this.state.menuCompacted && this.props.isOpen}
              id="menu-cartografic"
              infoPuntObert={this.props.infoPuntObert}
              alturaBtnSelectorFonsAux={this.props.alturaBtnSelectorFonsAux}
              onMouseOut={() => this.onHoverMenuCartografic(false)}
              onMouseEnter={() => this.onHoverMenuCartografic(true)}
              hovering={this.state.hovering}>
              <FondosWrapper alturaBtnSelectorFonsAux={this.props.alturaBtnSelectorFonsAux}>
                {this.props.alturaBtnSelectorFons > window.innerHeight / 2 && this.props.isOpen === true && this.state.menuCompacted === false
                  ? this.setState({ menuCompacted: true })
                  : null}
                {this.props.fonsData.map((carto, i) => {
                  // estabelcemos cuantas cartografias están visibles de inicio
                  let show =
                    window.innerHeight > 1000 ||
                    (window.innerHeight < 1000 && window.innerHeight >= 660) ||
                    (window.innerHeight < 660 && window.innerHeight > 375) ||
                    window.innerHeight <= 375;

                  //itera sobre todos los mapas cartográficos almacenados.
                  return (
                    <SFCMenuItem
                      key={i}
                      keyId={i}
                      show={show}
                      miniaturaCarto={carto.miniaturaCarto}
                      altMiniaturaCarto={carto.altMiniaturaCarto}
                      infoMiniaturaCarto={carto.infoMiniaturaCarto}
                      dataMiniaturaCarto={carto.dataMiniaturaCarto}
                      url={carto.dataUrl}
                      urlC={carto.dataUrlC}
                      fonsActiu={this.props.fonsActiu}
                      sliderWidth={this.state.sliderWidth}
                      transparenciaFons={this.props.transparenciaFons[i]}
                      onChangeTransparenciaMapa={(i, transp) => this.props.onChangeTransparenciaMapa(i, transp)}
                      onClickFonsMapa={() => this.onClickFonsMapa(i)}
                      fontSizeEnabled={this.props.fontSizeEnabled}></SFCMenuItem>
                  );
                })}
              </FondosWrapper>
            </SFCMenuWrapper>
          </SFCWrapper>
        </SFCContainer>
      </>
    );
  }
}
